<template lang="pug">
  #top
    .boxrow
      .box
        FamilyTree(
          :family="family"
          :type="type"
          :redraw="familyRedraw"
          @update_image="update_image"
        )
      .box
        RowTemplate
          template(slot="template")
            PriceResult(
              :イ="comma(イ)"
              :ハ="comma(ハ)"
              :ニ="comma(ニ)"
              :deathKouzyo="comma(priceData.deathKouzyo)"
              :taxPrice="comma(taxPrice)"
            )
        RowTemplate.line
          template(slot="template")
            SpouseList(
              :items="this.family.spouse"
              :drawCount="drawCount"
              @data_change="data_change"
            )
            ChildList(
              :items="this.family.parent"
              :drawCount="drawCount"
              child_key="grand_parent"
              @data_change="data_change"
            )
            ChildList(
              :items="this.family.brother"
              :drawCount="drawCount"
              child_key="grand_child"
              @data_change="data_change"
            )
    .stripe_background
      .alert_area
        h3 留意事項
        .msg 本シミュレーションは、お客様自身にて入力いただいた財産額と、令和3年8月現在の法令をもとに、単純な事態を仮定し相続税を簡易に概算するものであり、相続税額を確定するものではありません。
        .msg 本シミュレーション結果は大まかな相続税のご理解をサポートするものです。万一、この目的を超えるご利用をされたなどの場合には、お客さまに生じた不利益や損害などについて当社は責任を負いかねますので、あらかじめご了承ください。
        .msg 本シミュレーションはすべての財産及び債務について法定相続分により計算しております。
        .msg 相続分、保険金の受取人によって金額は変動いたします。
        .msg 不動産についてはご入力金額を元に算出しております。
        .msg 配偶者の相続税額については、配偶者の税額軽減特例を適用するものとして計算しています。配偶者の税額軽減の特例の適用を受けるためには要件があります。納付税額が0円で表示された場合でも、申告不要とは限りません。詳しくは、税理士等の専門家にご相談ください。
        .msg 障害者控除、未成年者控除等の税額控除や2割加算は考慮しておりません。
        .msg 本シミュレーションの法定相続人に関して、相続関係図は本人の配偶者、子、孫、父、母、祖父母、兄弟姉妹、甥、姪までとなっておりますので、それ以外の法定相続人が登場する場合やご質問などに関してはお問合せフォームよりご相談ください。
      .boxrow.grayborder
        ExpertArea(
          :イ="イ"
          :ハ="ハ"
          :ニ="ニ"
          :taxPrice="taxPrice"
          :priceData="priceData"
          :targetMemberCount="targetMemberCount"
          @expert_data="expert_data"
          @go_mail="go_mail"
        )
      .boxrow.grayborder(v-if="priceData.price04 > 0")
        HudosanArea(
          :priceData="priceData"
          @area_data="hudosan_data"
        )
      .boxrow.grayborder(v-if="targetMemberCount.total > 1")
        BengoshiArea(
          :priceData="priceData"
          @area_data="bengoshi_data"
        )
      .boxrow.grayborder
        ZaisanArea(
          :priceData="priceData"
          @area_data="zaisan_data"
          @go_mail="go_mail"
        )
      .boxrow.button_area
        button.blue_button(@click="output_pdf") シミュレーション結果（PDF）をダウンロード
        BackButton.back_button
      .image_bar
        img(:src="imagePath + 'img/left_peaple.png'")
        img(:src="imagePath + 'img/right_peaple.png'")
      form#form(method="post" :action="pdfUrl" target="_blank")
        input#pdfParam(type="hidden" name="data" value="")
</template>

<script lang="js">
import store from '@/store';
import step03Module from '@/module/step03Module';
import ApiClient from '@/module/api';
import FamilyTree from '@/components/page/FamilyTree.vue';
import PriceResult from '@/components/step03/PriceResult.vue';
import RowTemplate from '@/components/step03/RowTemplate.vue';
import SpouseList from '@/components/step03/SpouseList.vue';
import ChildList from '@/components/step03/ChildList.vue';
import ExpertArea from '@/components/step03/ExpertArea.vue';
import BengoshiArea from '@/components/step03/BengoshiArea.vue';
import HudosanArea from '@/components/step03/HudosanArea.vue';
import ZaisanArea from '@/components/step03/ZaisanArea.vue';
import BackButton from '@/components/module/BackButton.vue';

export default {
  components: {
    FamilyTree,
    PriceResult,
    RowTemplate,
    SpouseList,
    ChildList,
    ExpertArea,
    BengoshiArea,
    HudosanArea,
    ZaisanArea,
    BackButton,
  },

  data: () => ({
    type: 2,
    familyRedraw: false,
    family: {},
    priceData: {},
    expertData: {},
    bengoshiData: {},
    hudosanData: {},
    zaisanData: {},
    familyImageData: '',
    taxPrice: 0,
    drawCount: 1,
  }),
  computed: {
    イ() {
      return this.priceData.price - this.priceData.deathKouzyo;
    },
    ハ() {
      return 3000 + (600 * this.targetMemberCount.total);
    },
    ニ() {
      let price = this.イ - this.ハ;
      if (price < 0) {
        price = 0;
      }
      return price;
    },
    // 遺産計算対象者
    targetMemberCount() {
      return step03Module.targetMemberCount(this.family);
    },
    pdfUrl() {
      return process.env.VUE_APP_API_BASE_URL + '/pdf';
    },
    imagePath() {
      return process.env.BASE_URL;
    },
  },
  created() {
    this.$emit('change_mode', 3);
    let json = localStorage.getItem('_isan_data');
    if (json) {
      this.family = JSON.parse(json);
    }
    json = localStorage.getItem('_isan_price');
    if (json) {
      this.priceData = JSON.parse(json);
    }
    this.mathPrice();
  },
  methods: {
    comma(num) {
      return step03Module.comma(num);
    },
    data_change() {
      this.familyRedraw = !this.familyRedraw;
      this.mathPrice();
    },

    go_mail(e) {
      const postData = {
        family: step03Module.pdfFamilyParam(this.family),
        treeData: this.family,
        priceData: {
          price01: this.イ,
          price02: this.ハ,
          price03: this.ニ,
          price04: this.taxPrice,
        },
        expertData: this.expertData,
        bengoshiData: this.bengoshiData,
        hudosanData: this.hudosanData,
        zaisanData: this.zaisanData,
        totalCount: this.targetMemberCount,
      };
      store.dispatch('setPDFData', postData);
      this.$router.push('/mail');
    },

    output_pdf(e) {
      const postData = {
        family: step03Module.pdfFamilyParam(this.family),
        treeData: this.family,
        priceData: {
          price01: this.イ,
          price02: this.ハ,
          price03: this.ニ,
          price04: this.taxPrice,
          hudosan: this.priceData.price04,
        },
        expertData: this.expertData,
        bengoshiData: this.bengoshiData,
        hudosanData: this.hudosanData,
        zaisanData: this.zaisanData,
        totalCount: this.targetMemberCount,
      };
      document.querySelector('#pdfParam').value = JSON.stringify(postData);
      document.querySelector('#form').submit();
      // const api = new ApiClient();
      // api.post('/pdf', postData);
    },
    update_image(image) {
      this.familyImageData = image;
    },
    expert_data(data) {
      this.expertData = data;
    },
    bengoshi_data(data) {
      this.bengoshiData = data;
    },
    hudosan_data(data) {
      this.hudosanData = data;
    },
    zaisan_data(data) {
      this.zaisanData = data;
    },

    // 対象者の金額計算
    mathPrice() {
      this.taxPrice = 0;
      if (this.family.parent.length > 0) {
        step03Module.mathParent(this);
      } else if (this.family.brother.length > 0) {
        step03Module.mathBrother(this);
      } else {
        step03Module.mathChild(this);
      }
      this.drawCount ++;
    },
  },
};
</script>

<style lang="sass" scoped>
#top
  margin: auto
  .boxrow
    display: flex
    flex-direction: row
    margin: auto
    width: $max-width
    padding: 0 0 20px 0
    .base
      width: 100%
      margin-top: 0!important
      margin-bottom: 0 !important
    .box
      min-height: 100%
      width: 50%
      box-sizing: border-box
      &:nth-child(2)
        padding-left: 20px
    .line
      border-top: solid 1px $deep-gray
.button_area
  margin-top: 20px
  flex-direction: column!important
  align-items: center
  .blue_button
    width: 500px
    height: 60px
  .back_button
    margin-top: 20px
    width: 500px
.alert_area
  margin: auto
  max-width: $max-width
  padding: 20px
  background-color: $white
  border-radius: 10px
  h3
    font-size: 16px
    margin-bottom: 4px
  .msg
    font-size: 12px
    position: relative
    padding-left: 14px
    &:before
      content: "※"
      position: absolute
      left: 0
.stripe_background
  background-image: $stripe-image
  background-repeat: repeat
  padding: 40px 20px
.grayborder
  border: solid 4px $color-black
  background-color: $white
  border-radius: 20px
  padding: 20px!important
  margin: 30px auto!important
.image_bar
  display: flex
  justify-content: center
  align-items: center
  margin-bottom: 40px
  img
    height: 80px


@media screen and (max-width: $break-header)
  #top
    flex-direction: column
    height: 100%
    min-height: auto
    width: 100%
    .boxrow
      display: flex
      flex-direction: column-reverse
      margin: auto
      width: 100%
      padding: 0 30px 20px 20px
      .box
        width: 100%
  .button_area
    width: 100%
    .blue_button
      width: 100%
      height: auto
      border-radius: 0
    .back_button
      width: 100%
      height: auto
      border-radius: 0

  .image_bar
    flex-direction: column
    img
      height: 60px
</style>
